import fitvids from 'fitvids';
import $script from 'scriptjs';

const api = 'https://player.vimeo.com/api/player.js';
let apiLoaded = false;

export default class VimeoPlayer {
  constructor(el) {
    const url = el.getAttribute('data-video-url');
    const urlParts = url.split('/');

    this.el = el;
    this.id = urlParts[urlParts.length - 1];

    this.onApiLoaded = this._onApiLoaded.bind(this);

    this.onProgress = this._onProgress.bind(this);
    this.onProgressCallback = null;

    if (apiLoaded) {
      this._onApiLoaded();
    } else {
      $script(api, this.onApiLoaded);
    }
  }

  play() {
    return new Promise((resolve) => {
      this.onProgressCallback = resolve;
      this.player.on('progress', this.onProgress);
      this.player.play();
    });
  }

  unload() {
    this.player
      .unload()
      .catch();
  }

  _onApiLoaded() {
    this.player = new window.Vimeo.Player(this.el, { id: this.id });

    this.player
      .ready()
      .then(() => fitvids())
      .catch();

    apiLoaded = true;
  }

  _onProgress() {
    this.player.off('progress', this.onProgress);

    if (this.onProgressCallback) {
      this.onProgressCallback();
      this.onProgressCallback = null;
    }
  }
}
